var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.type))]),_c('span',{staticClass:"comment"},[_vm._v("*必填")])])}
var staticRenderFns = []

export { render, staticRenderFns }